'use strict';

console.log('init _bmkbm v1.5');

let variation;

const init_experiment = (exp_id, iteration = "v0.01", force_activate_variation) => {
  let exp_handle = exp_id.replace("-", "").toLowerCase();

  if(force_activate_variation){
    variation = force_activate_variation;
  } else {
    if(getParam("qa").indexOf(exp_handle) > -1){
      variation = getParam("qa").replace(exp_handle, "");
    } else {
      variation = window.sessionStorage.getItem(exp_id);
    }
  }

  let exp_tag = exp_handle + variation;
  document.documentElement.classList.add(exp_tag);
  console.log(`init ${exp_id}${variation} -- ${iteration}`);

  return variation;
};

function waitForElement(selector) {
  return new Promise(function(resolve, reject) {
    var element = document.querySelector(selector);

    if(element) {
      resolve(element);
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        var nodes = Array.from(mutation.addedNodes);
        for(var node of nodes) {
          if(node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        };
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
}

// shim layer with setTimeout fallback
const requestAnimFrame = (function () {
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 3000 / 60);
    };
})();

function waitUntil(test) {
  return new Promise(function(resolve){
    (function poll() {
      if (!test()) return requestAnimFrame(poll, 50);
      return resolve();
    })();
  });
};

const observeSelector = (selector, callback, options = { timeout: null, once: false, onTimeout: null, document: window.document })=>{
  let processed = new Map();

  if (options.timeout || options.onTimeout){
    console.log('------------------------------------------------------------------------------------------------------------------------------');
    console.log('WARNING: observeSelector options timeout and onTimeout are not yet implemented.');
    console.log('------------------------------------------------------------------------------------------------------------------------------');
  }

  let obs, isDone = false;
  const done = ()=>{
    if (!obs) console.warn('observeSelector failed to run done()');
    if (obs) obs.disconnect();
    processed = undefined;
    obs = undefined;
    return isDone = true;
  };

  const processElement = el=>{
    if (processed && !processed.has(el)) {
      processed.set(el, true);
      callback(el);
      if (options.once){
        done();
        return true;
      }
    }
  };

  const lookForSelector = (el = document) => {
    if (el.matches && el.matches(selector)){
      if (processElement(el)) return true;
    }
    if (el.querySelectorAll){
      const elements = el.querySelectorAll(selector);
      if (elements.length) {
        for (let i = 0; i < elements.length; i++) {
          const el = elements[i];
          if (processElement(el)) return true;
        }
      }
    }
  };
  lookForSelector();

  //We might finish before the mutation observer is necessary:
  if (!isDone){
    obs = new MutationObserver(mutationsList => {
      mutationsList.forEach(record=>{
        if (record && record.addedNodes && record.addedNodes.length){
          for (let i = 0; i < record.addedNodes.length; i++) {
            //Need to check from the parent element since sibling selectors can be thrown off if elements show up in non-sequential order
            const el = record.addedNodes[i].parentElement;
            // if (!el) console.warn('observeSelector element has no parent', record.addedNodes[i], record);
            //Note: This appears to also run when elements are removed from the DOM. If the element doesn't have a parent then we don't need to check it.
            if (el && lookForSelector(el)) return true;
          }
        }
      });
    });
    obs.observe(options.document || document, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }

  return ()=>{
    done();
  };
}; //_observeSelector

//helper functions
const getRandomInt = (min, max) =>{
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
  //The maximum is exclusive and the minimum is inclusive
}; // end getRandomInt()

const getParam = (name, optSearch) => {
  optSearch = optSearch || location.search;
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(optSearch);
  return results === null ?
    '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const testImage = (el) => {
  // console.log("testImage()",el);
  var tester=new Image();
  tester.onerror=imageNotFound(el);
  tester.src=el.src;
}; // end testImage();

const imageNotFound = (el) => {
  let endpoint = `${el.parentNode.href}.js`;
  console.log("imageNotFound()",endpoint);

  //updated handles are jolly good fun
  switch(el.parentNode.href){
    case "https://soundiron.com/products/sick-ii":
      endpoint = "https://soundiron.com/products/sick-2.js";
      break;
    case "https://soundiron.com/products/emotional-piano-kontakt-player-edition":
      endpoint = "https://soundiron.com/products/emotional-piano.js";
      break;
    case "https://soundiron.com/products/apocalypse-elements-kontakt-player-edition":
      endpoint = "https://soundiron.com/products/apocalypse-elements.js";
      break;
    case "https://soundiron.com/products/olympus-elements-kontakt-player-edition":
      endpoint = "https://soundiron.com/products/olympus-elements.js";
      break;
    case "https://soundiron.com/products/mercury-elements-player-edition":
      endpoint = "https://soundiron.com/products/mercury-elements.js";
      break;
    case "https://soundiron.com/products/requiem-light-kontakt-player-edition":
      endpoint = "https://soundiron.com/products/requiem-light-symphonic-choir.js";
      break;
    case "https://soundiron.com/products/little-epic-percussion-1":
      endpoint = "https://soundiron.com/products/little-epic-percussion.js";
      break;
    case "https://soundiron.com/products/kinderklavier-toy-piano":
      endpoint = "https://soundiron.com/products/kinderklavier.js";
      break;
    default:
    //none
  };

  $.getJSON(endpoint, (prod) => {
  }).success((prod) => {
    el.src = prod.featured_image;
    console.log("updated prod image");
  }).fail(() => {
    console.log("could not retrieve image at " + endpoint);
    el.style.display = "none";
  });

}; // end imageNotFound();

const init_blocknav = () => {
  console.log("init_blocknav()");
  waitForElement('.nav--desktop').then(desktop_nav => {
    desktop_nav.innerHTML = `
      <div class="mobile-wrapper">
        <a href="" class="menuToggle header-hamburger"></a>
        <div class="logo-container">
          <div class="h4 header-logo" itemscope="" itemtype="http://schema.org/Organization">
            <a href="/" itemprop="url">
              <img src="https://cdn.shopify.com/s/files/1/0371/2865/files/site_header_800x.png?v=1542736796" srcset="//cdn.shopify.com/s/files/1/0371/2865/files/site_header_800x.png?v=1542736796 1x, //cdn.shopify.com/s/files/1/0371/2865/files/site_header_800x@2x.png?v=1542736796 2x" alt="Soundiron" class="logo-image" itemprop="logo">
            </a>
          </div>
        </div>

        <a href="" class="menuToggle header-hamburger"></a>
      </div>

      <div class="header-menu nav-wrapper">
        <ul class="main-menu accessibleNav">
          <li><a class="nav-link shop-nav" id="si-shop-nav">
            <span>Shop</span>
            <span class="down-chevron"><svg viewBox="0 0 2048 2048" xmlns="http://www.w3.org/2000/svg"><path d="M1811 936l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"></path></svg></span>
          </a></li>
          <li><a href="/collections/bundles" class="nav-link">Bundles</a></li>
          <li><a href="/collections/on-sale" class="nav-link">On Sale!</a></li>
          <li><a href="/collections/new-releases" class="nav-link">New!</a></li>
          <li><a href="https://soundiron.com/collections/free" class="nav-link">Free</a></li>
          <li><a href="/blogs/news" class="nav-link">Blog</a></li>

          <li class="parent  kids-4">
            <a href="/pages/about-us" class="nav-link">Contact</a>
            <a href="#" class="nav-carat"><span class="plus">+</span><span class="minus">-</span></a>
            <div class="main-menu-dropdown">
              <ul>
                <li><a href="https://soundiron.com/pages/newsletter" class="nav-link">Newsletter</a></li>
                <li><a href="/pages/help" class="nav-link">FAQ</a></li>
                <li><a href="/pages/about-us" class="nav-link">About Us</a></li>
                <li><a href="/pages/contact-form" class="nav-link">Support</a></li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <div class="header__icons">
              <div class="header-search__wrapper_custom">
                <div class="header-search_custom">
                  <form action="/search" method="get" class="input-group search" role="search">
                    <input type="hidden" name="type" value="product">
                    <input class="search-bar" type="search" name="q">
                    <button type="submit" class="btn search-btn"></button>
                  </form>
                </div>
              </div>
              <div class="header-account-link_custom">
                <a href="/account"><img src="https://soundiron.com/cdn/shop/t/57/assets/account-icon.svg?v=142984812538170218541764253279"></a>
              </div>
            <div class="header-cart__wrapper_custom">
              <a href="/cart" class="CartToggle header-cart_custom"></a>
            </div>
        </div>
    `;

    desktop_nav.classList.add('blocknav-ready');

    // Block nav HTML is now rendered by Liquid section (cc-block-nav)
    // Move it inside .header-main so it follows the header (sticky or not)
    const blockNavEl = document.getElementById('si-block-nav');
    const headerMain = document.querySelector('.header-main');
    if (blockNavEl && headerMain) {
      headerMain.appendChild(blockNavEl);
    }

    waitForElement('#best-sellers-1').then(bs1 =>{
      waitForElement('#best-sellers-2').then(bs2 =>{
        waitForElement('#best-sellers-3').then(bs3 =>{

          for(let i = 0; i < nav_best_sellers.length; i++){
            let nav_slider_item = `
              <a href="${ nav_best_sellers[i].url }" class="nav-slider--item">
                <div class="image">
                  <img src="${ nav_best_sellers[i].image }" />
                </div>
                <div class="title">
                  ${ nav_best_sellers[i].title }
                </div>
                <div class="price">
                  ${ nav_best_sellers[i].price }
                </div>
              </a>
            `;
            if(i < 5){
              bs1.querySelector('.nav-slider--slides').insertAdjacentHTML("beforeend", nav_slider_item);
            } else if(i < 10){
              bs2.querySelector('.nav-slider--slides').insertAdjacentHTML("beforeend", nav_slider_item);
            } else if (i < nav_best_sellers.length) {
              bs3.querySelector('.nav-slider--slides').insertAdjacentHTML("beforeend", nav_slider_item);
            }

            if(i === nav_best_sellers.length-1){
              //last loop
              bs1.querySelector('.nav-slider--slides').insertAdjacentHTML("beforeend", bs1.querySelector('.nav-slider--slides').innerHTML);
              bs2.querySelector('.nav-slider--slides').insertAdjacentHTML("beforeend", bs2.querySelector('.nav-slider--slides').innerHTML);
              bs3.querySelector('.nav-slider--slides').insertAdjacentHTML("beforeend", bs3.querySelector('.nav-slider--slides').innerHTML);
            }

          }

        }).catch();
      }).catch();
    }).catch();

    waitForElement('#si-shop-nav').then(shopNav => {
      console.log("got shopNav");
      waitForElement('#si-block-nav').then(blockNav => {
        console.log("got blockNav");
        // === MEGANAV POSITIONING ===
        // State A: at top of page (header not sticky) → meganav below header
        // State B: scrolled down (header sticky) → meganav full viewport top:0

        let meganavScrollHandler = null;
        let meganavClickOutsideHandler = null;

        function updateMeganavPosition() {
          const headerMain = document.querySelector('.header-main');
          if (!headerMain) return;

          // Always position below the header's actual bottom edge
          // This works for all states: top of page, sticky visible, sticky hidden
          const bottom = headerMain.getBoundingClientRect().bottom;

          if (bottom <= 0) {
            // Header is fully scrolled off or hidden — full viewport
            blockNav.style.top = '0';
            blockNav.style.maxHeight = '100vh';
          } else {
            // Header is visible (sticky or static) — sit below it
            blockNav.style.top = bottom + 'px';
            blockNav.style.maxHeight = 'calc(100vh - ' + bottom + 'px)';
          }
        }

        function openMeganav() {
          // Move to body so position:fixed works (header-main's transform breaks it)
          document.body.appendChild(blockNav);

          updateMeganavPosition();
          shopNav.classList.add('active');
          blockNav.classList.add('active');
          blockNav.classList.add('pinned');

          // Update position on scroll (handles state transitions while open)
          meganavScrollHandler = function() {
            if (blockNav.classList.contains('active')) {
              updateMeganavPosition();
            }
          };
          window.addEventListener('scroll', meganavScrollHandler, { passive: true });

          // Click outside to close
          setTimeout(function() {
            meganavClickOutsideHandler = function(e) {
              if (!blockNav.contains(e.target) && !shopNav.contains(e.target)) {
                closeMeganav();
              }
            };
            document.addEventListener('click', meganavClickOutsideHandler);
          }, 100);
        }

        function closeMeganav() {
          shopNav.classList.remove('active');
          blockNav.classList.remove('active');
          blockNav.classList.remove('pinned');
          blockNav.style.top = '';
          blockNav.style.maxHeight = '';

          // Remove scroll and click-outside listeners
          if (meganavScrollHandler) {
            window.removeEventListener('scroll', meganavScrollHandler);
            meganavScrollHandler = null;
          }
          if (meganavClickOutsideHandler) {
            document.removeEventListener('click', meganavClickOutsideHandler);
            meganavClickOutsideHandler = null;
          }

          // Move back inside header-main
          const headerMain = document.querySelector('.header-main');
          if (headerMain) headerMain.appendChild(blockNav);
        }

        shopNav.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (shopNav.classList.contains('active')) {
            closeMeganav();
          } else {
            openMeganav();
          }
        });

        const closeBtn = document.getElementById('si-block-nav-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            closeMeganav();
          });
        }

        // Header hide/show on scroll (only when meganav is closed)
        let previousPosition = window.pageYOffset || document.documentElement.scrollTop;
        let currentPosition;

        let scrolling = false;
        window.onscroll = () => {
          scrolling = true;
        };

        setInterval(() => {
          const headerNav = document.querySelector('header');
          if(scrolling) {
            scrolling = false;
            currentPosition = window.pageYOffset || document.documentElement.scrollTop;

            // Don't hide header when meganav is open
            if(blockNav.classList.contains('active')) {
              previousPosition = currentPosition;
              return;
            }

            if(window.pageYOffset < 100){
              headerNav.classList.remove("inactive");
            } else {
              if (previousPosition > currentPosition) {
                headerNav.classList.remove("inactive");
              } else {
                headerNav.classList.add("inactive");
              }
            }
            previousPosition = currentPosition;
          }
        }, 150 );

      }).catch();
    }).catch();
  }).catch();

}; // end init_blocknav()

const init_getParams = () => {
  console.log("init_getParams()");
  if(getParam("soundiron-vid")){
    console.log("init_getParams(soundiron-vid)");
    let vid_id = getParam("soundiron-vid");
    let vid_selector = `[data-id=yt-${vid_id}]`;
    let vid = document.querySelector(vid_selector);
    vid.click();
  }
}; //end init_getParams()

const cookie = {
  /**
   * @desc set() sets a cookie with optional days
   *  @param {String} name - the name of the cookie
   *  @param {String} value - the value of the cookie
   *  @param {Number} optDays - days the cookie will exist for
   *    NOTE: Not passing optDays will create a "Session Cookie"
   *  @param {String} domain - the domain value of the cookie
   *    Example: ".domain.com" would span all sub domains of domain.com
   *  @return {Undefined}
   */
  set(name, value, optDays, domain) {
    let cookie = name + '=' + value;
    if (optDays) {
      const date = new Date();
      date.setTime(date.getTime() + (optDays * 24 * 60 * 60 * 1000));
      cookie += '; expires=' + date.toGMTString();
    }
    if (domain){
      cookie += '; domain=' + domain;
    }
    document.cookie = cookie + '; path=/';
  },
  /**
   * @desc get() gets value of cookie
   *  @param {String} name - name of cookie to get
   *  @return {String|Null} - string value of cookie NOT A BOOL!
   *
   */
  get(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  /**
   * @desc del() removes cookie
   *  @param {String} name - name of cookie to delete
   *  @return {Undefined}
   */
  del(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  },
};

const init_cookies = (param, value)=>{
  return new RegExp(`(^|; )${param}${value !== undefined ?`=${value}`:'(=.*)?'}(;|$)`).test(document.cookie);
};

const init_favorites = () => {

  document.documentElement.classList.add("js-favorites-enabled");

  //favorites
  let favs = document.querySelectorAll(".favorites");
  for(let i = 0; i < favs.length; i++){

    //init favorites icon
    let grid_item = favs[i].closest(".product-grid-item");
    if(window.localStorage.getItem(favs[i].id)){
      favs[i].querySelector(".svg-icon--heart").classList.remove("active");
      favs[i].querySelector(".svg-icon--heart-filled").classList.add("active");
      if(grid_item){
        grid_item.classList.add("js-is-fav");
      }
    } else {
      favs[i].querySelector(".svg-icon--heart").classList.add("active");
      favs[i].querySelector(".svg-icon--heart-filled").classList.remove("active");
    }

    //update favorites
    favs[i].querySelector(".favorites--btn").addEventListener("click",() => {
      let btn = favs[i].querySelector(".favorites--btn");
      let heart = favs[i].querySelector(".svg-icon--heart");
      let heart_filled = favs[i].querySelector(".svg-icon--heart-filled");
      console.log(grid_item);

      if(window.localStorage.getItem(favs[i].id)){
        console.log(`${favs[i].id} removed`);
        window.localStorage.removeItem(favs[i].id);
        heart.classList.add("active");
        heart_filled.classList.remove("active");
        if(grid_item){
          grid_item.classList.remove("js-is-fav");
        }
      } else {
        console.log(`${favs[i].id} added`);
        window.localStorage.setItem(favs[i].id, 'true');
        heart.classList.remove("active");
        heart_filled.classList.add("active");
        if(grid_item){
          grid_item.classList.add("js-is-fav");
        }
      }
    });
  }
}; // end init_favorites()

const init_mobile_menu_actions = () =>{
  console.log("init_mobile_menu_actions");
  let menu_toggle = document.querySelector("#mobile-menu-toggle");
  menu_toggle.style.border = "10px solid red";
  menu_toggle.addEventListener("click",(e) => {
    console.log("click","init_mobile_menu_actions");
    let doc_body = document.querySelector("body");
    if(doc_body.classList.contains(".mobile-menu-active")){
      doc_body.classList.remove(".mobile-menu-active");
    } else {
      doc_body.classList.add(".mobile-menu-active")
    }
  });
}; // end init_mobile_menu_actions();

const bmkbm_init = () => {

  //hide KMI from collections
  if(window.location.pathname === "/collections"){
    var kmiLink = document.querySelector('a[href="/collections/kmi-kboard-pro4-100-off-hyperion-strings-apocalypse-micro"]');
    if(kmiLink) {
      var kmiItem = kmiLink.closest('.collection-list-item');
      if(kmiItem) kmiItem.classList.add("js-hidden");
    }
  }

  // START -- changes for bundles
  if(document.querySelector("#contents")){
    // console.log("this is a Bundle PDP");
    let bundle_item_images = document.querySelectorAll("#contents a img");
    for(let i=0; i<bundle_item_images.length; i++){
      if(bundle_item_images[i].closest(".product-section").id !== "kontakt"){
        testImage(bundle_item_images[i]);
      }
    }
  } else {
    // console.log("this is not a Bundle PDP");
  }
  // END -- changes for bundles

  // START -- Custom GA Events Tracking (M.A.P. + Omega Blog Promo)
  let pcp_map_view_prod = document.querySelector("#map-view-prod");
  let pcp_map_prod_details_title = document.querySelector("#map-prod-details-title");
  let pcp_map_prod_details_image = document.querySelector("#map-prod-details-image");
  let pdp_map_buy_now = document.querySelector("#map-buy-now");

  if(pcp_map_view_prod && pcp_map_prod_details_title && pcp_map_prod_details_image){
    pcp_map_view_prod.addEventListener("click", (e) => {
      if(typeof ga === 'function') ga('send', 'event', 'M.A.P.', 'Click', 'PCP: View Product CTA');
    });
    pcp_map_prod_details_title.addEventListener("click", (e) => {
      if(typeof ga === 'function') ga('send', 'event', 'M.A.P.', 'Click', 'PCP: Title (product details)');
    });
    pcp_map_prod_details_image.addEventListener("click", (e) => {
      if(typeof ga === 'function') ga('send', 'event', 'M.A.P.', 'Click', 'PCP: Image (product details)');
    });
  }

  if(pdp_map_buy_now){
    pdp_map_buy_now.addEventListener("click", (e) => {
      if(typeof ga === 'function') ga('send', 'event', 'M.A.P.', 'Click', 'PDP: Buy Now CTA');
    });
  }

  let blog_omega_promo = document.querySelector(".blog__article__content a[href*='the-omega-bundle-discount-plan']");
  if (blog_omega_promo){
    blog_omega_promo.addEventListener("click", ()=>{
      if(typeof ga === 'function') ga('send', 'event', 'Blog Promo - Omega Bundle', 'Ad Clicked', 'Blog Article Footer');
    });
  }

  // END -- Custom GA Events Tracking (M.A.P. + Omega Blog Promo)

}; // end bmkbm_init()


const launch_modal = (content) => {

  document.querySelector("main").insertAdjacentHTML("beforebegin",`
  <div class="js-overlay"></div>
  <div class="js-modal">
    <div class="js-modal--content">
      <div class="js-modal--close">
        &times;
      </div>
      <div class="js-modal--video">
        ${content}
      </div>
    </div>
  </div>
  `);

  setTimeout(() => {
    let overlay = document.querySelector(".js-overlay");
    let modal = document.querySelector(".js-modal");
    let modal_content = document.querySelector(".js-modal--content");
    let close_btn = document.querySelector(".js-modal--close");
    overlay.classList.add("active");
    modal.classList.add("active");

    const dismiss_modal = () => {
      overlay.classList.remove("active");
      modal.classList.remove("active");
      setTimeout(() => {
        overlay.remove();
        modal.remove();
      },250);
    };

    //off-modal clicks
    overlay.addEventListener("click",(e) =>{
    	console.log("overlay click",e.target);
      if(!modal_content.contains(e.target)){
        dismiss_modal();
      }
    });

    //esc key press
    document.onkeydown = (e) => {
      if(e.key === "Escape" || e.keyCode === 27) {
        dismiss_modal();
      }
    };

    close_btn.addEventListener("click", dismiss_modal);
  },50);
};

/*
Examples: https://crometrics.quip.com/Eo6bAVnmFHZx/Cromedics-Modules
Usage:
import scrollIt from 'cromedics/scrollIt';
scrollIt(element);
*/

const easings = {
  linear(t) {
    return t;
  },
  easeInQuad(t) {
    return t * t;
  },
  easeOutQuad(t) {
    return t * (2 - t);
  },
  easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  easeInCubic(t) {
    return t * t * t;
  },
  easeOutCubic(t) {
    return (--t) * t * t + 1;
  },
  easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  easeInQuart(t) {
    return t * t * t * t;
  },
  easeOutQuart(t) {
    return 1 - (--t) * t * t * t;
  },
  easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
  },
  easeInQuint(t) {
    return t * t * t * t * t;
  },
  easeOutQuint(t) {
    return 1 + (--t) * t * t * t * t;
  },
  easeInOutQuint(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
  }
};

const scrollIt = (destination, duration = 200, easing = 'linear', callback) => {
  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  let scroll = () => {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - startTime) / duration));
    const timeFunction = easings[easing](time);
    const yPos = Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start);
    window.scroll(0, yPos);

    if (yPos === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  }
  scroll();
};

const isElementInView = (el, pixelsShown = 0)=>{
  const s1 = el.offsetTop + el.offsetHeight - window.scrollY;
  const s2 = window.scrollY + window.innerHeight - el.offsetTop;
  return s1 > pixelsShown && s2 > pixelsShown;
};

const init_sound_samples = () => {
  let countdown;
  let sampler_playing = false;
  let sample_btns = document.querySelectorAll(".btn--sound-sample");

  const sampler_actions = (el) => {
    let sample_track_id = el.getAttribute("data-sample-id");
    let container = el.closest(".grid-item--buttons");
    if(!container.classList.contains("sampler-playing")){
      //this element's sampler is not currently playing
      if(sampler_playing){
        //stop the track that's playing
        stop_sampler();
        //wait until the other track is stopped, then start this track
        waitUntil(() => {
          return sampler_playing == false;
        }).then(() => {
          start_sampler(container, sample_track_id);
        }).catch();
        if(typeof ga === 'function') ga('send', 'event', 'Samples Player', 'Click', 'Quick Browse Multi Track');
      } else {
        //nothing is playing, just start
        start_sampler(container, sample_track_id);
        if(typeof ga === 'function') ga('send', 'event', 'Samples Player', 'Click', 'Started');
      }
    } else {
      //just stop this track
      if(typeof ga === 'function') ga('send', 'event', 'Samples Player', 'Click', 'Player Stopped');
      stop_sampler();
    }
  };

  const start_sampler = (container, sample_track_id) => {
    sampler_playing = true;
    container.classList.add("sampler-playing");
    container.insertAdjacentHTML("beforeend",`
    <div class="sound-bars" id="sound-sampler">
    <div class="sampler-time">

      <span id="sampler-time">30</span>s</div>

      <div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div><div class="bar"></div>

      <iframe width="100px" height="100" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${sample_track_id}&color=%23ff5500&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=false"></iframe>
    </div>
    `);
    waitForElement('#sampler-time').then(timer => {
      let seconds = timer.textContent;
      start_countdown(seconds);
    }).catch();
  };

  const start_countdown = (seconds) => {
    countdown = setInterval(() => {
      // console.log("----",seconds);
      seconds--;
      waitForElement('#sampler-time').then(el => {
        el.textContent = seconds;
      });
      if (seconds <= 0){
        stop_sampler();
        if(typeof ga === 'function') ga('send', 'event', 'Samples Player', 'Stop', 'Full Track Played');
      }
    }, 1000);
  };

  const stop_countdown = () => {
    // console.log("stop countdown");
    clearInterval(countdown);
  };

  const stop_sampler = () => {
    sampler_playing = false;
    waitForElement("#sound-sampler").then(sampler => {
      sampler.closest(".grid-item--buttons").classList.remove("sampler-playing");
      sampler.remove();
    });
    stop_countdown();
  };

  if(sample_btns.length > 0){
    for(let i=0; i<sample_btns.length; i++){
      sample_btns[i].classList.remove("disabled");
      sample_btns[i].addEventListener("click",() => {
        sampler_actions(sample_btns[i]);
      });
    }
  }
};

const init_adjust_free_price = () => {
  let grid_item_prices = document.querySelectorAll('.grid-item--price');
  for(let i = 0; i < grid_item_prices.length; i++){
    if(grid_item_prices[i].innerText === "$ 0"){
      grid_item_prices[i].innerText = "FREE!";
    }
  }
};

const init_cpc_featured = () => {
  console.log("init featured slider");
  if(window.location.href.indexOf("/collections/") > -1 && window.location.href.indexOf("/kontakt-player-edition-collection") === -1 && window.innerWidth > 1000){
    waitForElement('[data-section-id="collection"] .content').then(hero => {

        document.querySelector('.collection-hero').classList.add("featured-slider-active");
        let featured_products = document.querySelectorAll('#featured-products .product-grid-item');
        console.log("---featured_products", featured_products.length);

        for(let i = 0; i < featured_products.length; i++){
          if(featured_products[i].querySelectorAll(".grid-item--short-desc").length > 0){
            featured_products[i].querySelector(".grid-item--short-desc").classList.remove("js-hidden");
          }
        }

        hero.insertAdjacentHTML("beforeend", `
          <div id="featured-products-slider" class="js-slider--products"></div>
        `);

        waitForElement('#featured-products-slider').then(slider => {

          if(getParam("style")){
            let style_version = getParam("style")
            // slider.classList.add(`js-style-${style_version}`);
          }

          slider.classList.add(`js-style-1`);

          slider.insertAdjacentElement("beforeend", featured_products[0]);
          featured_products[0].classList.add("featured");
          $('#featured-products-slider').slick({
            infinite: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
          });

        }).catch();

    }).catch();
  }
};

//activation
document.addEventListener("DOMContentLoaded", function () {

  if(getParam("stealth-mode") === "active" || getParam("stealth-mode") === "activate"){
    sessionStorage.setItem("stealth-mode", "active");
  }

  if(sessionStorage.getItem("stealth-mode")){
    document.querySelector("body").insertAdjacentHTML("afterbegin", `
      <div style="padding:10px; background: #ccc; position: fixed; top:10px; left: 10px; z-index: 999999; text-align:center;">
        Stealth mode is active. <div id="js-deactivate-stealth" style="border-radius: 5px; border:1px solid #666666; padding: 5px; cursor:pointer;">Deactivate Stealth Mode</div>
      </div>
    `);
    waitForElement('#js-deactivate-stealth').then(el => {
      el.addEventListener("click", () => {
        sessionStorage.removeItem("stealth-mode");
        window.location = window.location.pathname;
      });
    }).catch();
  }


  bmkbm_init();
  init_getParams();
  init_cookies();
  init_mobile_menu_actions();
  init_sound_samples();
  init_adjust_free_price();
  init_cpc_featured();
  if(window.innerWidth > 1150){
    init_blocknav();
  }
  if(getParam("stealth-mode") === "active" || sessionStorage.getItem("stealth-mode")){
    init_favorites();
  }
  console.log("_bmkbm no errors");
});

switch (document.readyState) {
  case "loading":
    // The document is still loading.
    console.log("readystate loading...");
    break;
  case "interactive":
    // The document has finished loading. We can now access the DOM elements.
    // But sub-resources such as scripts, images, stylesheets and frames are still loading.
    console.log("readystate interac...");
    break;
  case "complete":
    // The page is fully loaded.
    console.log("readystate comppp...");
}
